
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const RivieraCharityPage = lazy(() => import('../pages/riviera-charity/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RivieraCharityPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
